import { useState } from 'react';
import { Link, router } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
import TeacherShell, { TeacherPageHeader } from '../../../components/layout/TeacherShell';
import { Card, Button, Input, Textarea, InputLabel, InputGroup } from '../../../components/ui';
import BookPicker from '../../../components/BookPicker';

export default function CoursesNew({ available_books }) {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    starts_on: '',
    ends_on: '',
    library_item_ids: [],
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    router.post('/teacher/courses', { course: formData }, {
      onFinish: () => setIsSubmitting(false),
    });
  };

  return (
    <TeacherShell scrollTitle={t('teacherCourseNew.title')}>
      <TeacherPageHeader
        title={t('teacherCourseNew.title')}
        subtitle={t('teacherCourseNew.subtitle')}
        backLink="/teacher/courses"
        backLabel={t('teacherCourseNew.backToCourses')}
      />

      <div className="max-w-2xl">
        <Card className="p-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            <InputGroup>
              <InputLabel htmlFor="title" required>{t('teacherCourseNew.titleField')}</InputLabel>
              <Input
                id="title"
                value={formData.title}
                onChange={handleChange('title')}
                placeholder={t('teacherCourseNew.titlePlaceholder')}
              />
            </InputGroup>

            <InputGroup>
              <InputLabel htmlFor="description">{t('teacherCourseNew.description')}</InputLabel>
              <Textarea
                id="description"
                value={formData.description}
                onChange={handleChange('description')}
                placeholder={t('teacherCourseNew.descriptionPlaceholder')}
                rows={4}
              />
            </InputGroup>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <InputGroup>
                <InputLabel htmlFor="starts_on">{t('teacherCourseNew.startDate')}</InputLabel>
                <Input
                  id="starts_on"
                  type="date"
                  value={formData.starts_on}
                  onChange={handleChange('starts_on')}
                />
              </InputGroup>
              <InputGroup>
                <InputLabel htmlFor="ends_on">{t('teacherCourseNew.endDate')}</InputLabel>
                <Input
                  id="ends_on"
                  type="date"
                  value={formData.ends_on}
                  onChange={handleChange('ends_on')}
                  min={formData.starts_on || undefined}
                />
              </InputGroup>
            </div>

            {available_books && available_books.length > 0 && (
              <BookPicker
                books={available_books}
                selectedIds={formData.library_item_ids}
                onChange={(ids) => setFormData((prev) => ({ ...prev, library_item_ids: ids }))}
              />
            )}

            <div className="flex items-center gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
              <Button type="submit" variant="primary" disabled={isSubmitting || !formData.title.trim()}>
                {isSubmitting ? t('teacherCourseNew.creating') : t('teacherCourseNew.createCourse')}
              </Button>
              <Link href="/teacher/courses">
                <Button type="button" variant="ghost">{t('common.cancel')}</Button>
              </Link>
            </div>
          </form>
        </Card>
      </div>
    </TeacherShell>
  );
}
